export default __webpack_public_path__ + "static/media/timer.a9511ac8.svg";